import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-metabase-selected-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './metabase-selected-dialog.component.html',
  styleUrl: './metabase-selected-dialog.component.scss'
})
export class MetabaseSelectedDialogComponent {
  constructor(public dialogRef: MatDialogRef<MetabaseSelectedDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
